import axiosInstance from "app/axios";
import { AxiosResponse } from "axios";


export function patchConfirm(token: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.patch("user/confirm", {token});
}

